import httpClient from "../../api/httpClient";
import KeyValue from "../classes/KeyValue";
import Propriedade from "../classes/Propriedade";


interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "ParametrosDomain/All/" },
  { method: "GET", rota: "ParametrosDomain/" },
  { method: "POST", rota: "ParametrosDomain/Adicionar" },
  { method: "PUT", rota: "ParametrosDomain/Atualizar" },
  { method: "POST", rota: "ParametrosDomain/Apagar" },
  { method: "POST", rota: "ParametrosDomain/Listar/ModalidadeProducao/Centro/" },
];

const cacheKey: string = "ParametrosDomainCache";
const cacheKeySelC: string = "ParametrosDomainCacheSelecionado";

const apiServico: String = "PORTAL"

class PropriedadeDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }
  Adicionar(value: Propriedade) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async Atualizar(value: Propriedade) {
    return await super.putWithouTry(calls[3].rota, value).then(() => {}).catch((error) => {
      return error.response.data;
    });
  }

  async Apagar(value: Propriedade) {
    return await super.post(calls[4].rota, value).then(() => {}).catch((error) => {
      return error.response.data;
    });
  }

  async ListarAtivos(): Promise<Propriedade[]> {
    return await super.Get(calls[0].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async RecuperarPorId(id: number): Promise<Propriedade> {
    return await super.Get(calls[1].rota + id)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarCentrosVirtuais(): Promise<KeyValue[]> {
    return await super.post(calls[5].rota , '')
      .then((response) => {
        return JSON.parse(JSON.stringify(response));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): Propriedade[] {
    let result: Propriedade[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: Propriedade[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default PropriedadeDataset;

